import { Grid, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  EngagementLevel,
  clearUserActivityProgress,
  getUserActivityProgressRequest,
} from '../../redux/client/clientSlice';
import OverallEngagement from './Engagement/OverallEngagement';
import WhatAIThinks from './Engagement/WhatAIThink';
import ProgressAsReported from './Engagement/ProgressAsReported';
import Activities from './Engagement/Activities';

function ClientProgress() {
  const { id: clientId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const completedActivityProgress = useAppSelector((state) => state.client.clientProgress);
  const coachId = useAppSelector((state) => state.coach.coach?.id);
  const [transformedEngageData, setTransformedEngageData] = useState<EngagementLevel[]>([]);
  const theme = useTheme();

  useEffect(() => {
    dispatch(
      getUserActivityProgressRequest({
        clientId: clientId!,
        coachId: coachId!,
      })
    );
  }, []);

  useEffect(() => {
    const engageData = completedActivityProgress.engagementLevels.map((data) => ({
      date: data.date,
      engagementLevel: data.engagementLevel as 'NONE' | 'PARTIAL' | 'FULL' | 'NO_DATA',
    }));
    setTransformedEngageData(engageData);
  }, [completedActivityProgress]);

  useEffect(
    () => () => {
      dispatch(clearUserActivityProgress());
    },
    []
  );

  return (
    <Grid
      mt="24px"
      display="flex"
      flexDirection="column"
      gap={6}
      pb="30px"
      id="single-activity-progress"
      height="75vh"
      sx={{
        overflowX: 'hidden',
        overflowY: 'scroll',
        paddingRight: '10px',
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(93,171,201,0.5)',
          borderRadius: '10px',
        },
      }}
    >
      {/* First row */}
      <Grid display="flex" flexDirection="column" gap="20px">
        <Grid
          display="flex"
          flexDirection="column"
          gap="12px"
          p={3}
          bgcolor="#FFF"
          boxShadow={theme.borderStyles.cardBorders}
          width="100%"
          borderRadius="10px"
        >
          <OverallEngagement transformedEngageData={transformedEngageData} />
        </Grid>
        <Grid display="flex" flexDirection="row" gap="20px">
          <Grid
            item
            xs={6}
            gap={2}
            display="flex"
            flexDirection="column"
            p={3}
            bgcolor="#FFF"
            boxShadow={theme.borderStyles.cardBorders}
            borderRadius="10px"
          >
            <ProgressAsReported
              objectiveProgress={completedActivityProgress.objectiveProgressData}
            />
          </Grid>

          <Grid
            item
            xs={6}
            display="flex"
            flexDirection="column"
            p={3}
            bgcolor="#FFF"
            boxShadow={theme.borderStyles.cardBorders}
            borderRadius="10px"
          >
            <WhatAIThinks
              whatAiThinks={completedActivityProgress.suggestions.progress as string[]}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Second row */}
      <Grid>
        <Activities />
      </Grid>
    </Grid>
  );
}

export default ClientProgress;
